<template>
	<b-card
		no-body
		class="tw-border-none"
	>
		<b-card-body class="px-lg-5">
			<template v-if="emailSent">
				<b-card>
					<b-card-body>
						A Password reset email is sent to <span class="tw-text-green-3fa">{{model.email}}</span>. Please check your inbox and follow the link to reset your password.
					</b-card-body>
				</b-card>
			</template>
			<template v-else>
				<b-alert
					show
					class="mb-3"
					variant="danger"
					v-if="errorMessage"
				>{{errorMessage}}</b-alert>
				<validation-observer
					v-slot="{handleSubmit}"
					ref="formValidator"
				>
					<b-form
						role="form"
						@submit.prevent="handleSubmit(onSubmit)"
					>
						<base-input
							alternative
							name="Email"
							class="mb-3"
							:rules="{required: true, email: true}"
							prepend-icon="ni ni-email-83"
							placeholder="Correo electrónico"
							v-model="model.email"
							@input="errorMessage=null"
						>
						</base-input>

						<div class="tw-flex tw-flex-col tw-items-center">
							<base-button
								type="success"
								native-type="submit"
								class="mt-4 tw-bg-green-3fa tw-border-green-3fa"
							>Restablecer la contraseña</base-button>

							<router-link
								to="/login"
								class="tw-mt-4 tw-text-green-600"
							>Login instead</router-link>
						</div>
					</b-form>
				</validation-observer>
			</template>
		</b-card-body>
	</b-card>
</template>
<script>
import { Auth } from '../../firebase'
export default {
	data() {
		return {
			emailSent: false,
			errorMessage: null,
			model: {
				email: '',
			}
		};
	},
	methods: {
		async onSubmit() {
			Auth.sendPasswordResetEmail(this.model.email)
				.then(() => {
					this.emailSent = true
				})
				.catch((error) => {
					this.errorMessage = error.message;
				});
		}
	}
};
</script>
